import { useGetOfferMeetingQuery } from '../api';

/**
 * Hook para obtener la meeting de una oferta.
 * Uso: const { meeting, isLoading, isScheduled } = useOfferMeeting(offerId)
 */
export function useOfferMeeting(offerId: string | undefined) {
  const { data, isLoading, isError, error, refetch } = useGetOfferMeetingQuery(
    { offer_id: offerId! },
    { skip: !offerId }
  );

  return {
    meeting: data ?? null,
    isLoading,
    isError,
    error,
    refetch,
    isScheduled: data?.meeting_status === 'scheduled',
    hasSlots: data?.meeting_status === 'slots_proposed',
  };
}
